import Swiper from "swiper";
import { A11y, Autoplay, EffectFade, Pagination } from "swiper/modules";
import "@styles/components/slider.css";

document.querySelectorAll(".element-callouticonlist").forEach((el) => {
  const container = el.querySelector(".swiper");
  const sliderPagination = el.querySelector(".slider-pagination");

  const swiper = new Swiper(container, {
    modules: [A11y, Autoplay, EffectFade, Pagination],
    autoplay: {
      delay: 4000,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    speed: 700,
    pagination: {
      el: sliderPagination,
      clickable: true,
    },
    spaceBetween: 16,
    breakpoints: {
      768: {
        effect: "slide",
        slidesPerView: 3,
        spaceBetween: 24,
      },
    },
  });

  swiper.autoplay.stop();

  const observer = new IntersectionObserver(
    ([e]) => {
      if (e.isIntersecting) {
        swiper.autoplay.start();
        observer.disconnect();
      }
    },
    {
      threshold: [0.7],
    },
  );

  observer.observe(el);
});
